import React, { useState, useEffect, useMemo } from 'react';
import { FiExternalLink, FiGithub, FiChevronLeft, FiChevronRight } from "react-icons/fi";
import { usePersona } from '../persona/PersonaContext';

const ProjectsSection = () => {
  const persona = usePersona();
  const [, setHoveredProject] = useState(null);
  const [currentPage, setCurrentPage] = useState(0);
  const projectsPerPage = 6;
  const [selectedCategory, setSelectedCategory] = useState(null);

  // Only showing the projects array section that needs updating

const projects = useMemo(() => [
  {
    title: "LIPAWORLD",
    description: "Stablecoin remittance infrastructure across 7 African countries with per-corridor settlement reconciliation, provider failover, and multi-currency disbursement tracking on Circle USDC, Plaid, Buupass, and HiFi. Integrated M-Pesa, MTN MoMo, and Airtel Money as off-ramp providers. Real-time settlement tracking on Apache Druid with KYC gates at each stage.",
    category: ["Backend", "Payments", "Web3", "Africa"],
    link: "https://www.lipaworld.com/",
    coverImage: "/projects/lipaworld.png",
    type: "image"
  },
  {
    title: "REFLEX MULTIMEDIA",
    description: "DevRel and developer-tooling work for a commercial C++ framework. Built the in-product AI assistant with a two-agent RAG pipeline (generator and checker) over a curated knowledge base, hybrid retrieval combining a concept router, an example-matcher, and vector search on Supabase pgvector, plus a regex anti-pattern matcher for framework-specific syntax. Also contribute to the web platform, example apps, tutorials, and documentation.",
    category: ["C++", "AI", "RAG", "DevRel", "Framework"],
    link: "https://www.reflexmultimedia.com/",
    coverImage: "/projects/reflex.png",
    type: "image"
  },
  {
    title: "ODAFLOW",
    description: "Multi-tenant ordering platform serving 60+ enterprise clients including Coca-Cola and Naivas. Designed data architecture supporting distributors, sales reps, and retail networks under one schema. Built real-time order sync, role-based access spanning five user levels, and containerized AWS EC2 deployments. Python/Django backend, PostgreSQL, 1,500+ weekly transactions.",
    category: ["Backend", "AWS", "Python"],
    link: "https://odaflow.com/",
    coverImage: "/projects/odaflow.png",
    type: "image"
  },
  {
    title: "CHESSIE",
    description: "Chess training and analysis web app with Stockfish-powered engine evaluation, opening practice, and flagged-position drills. Built on Next.js with a custom backend for user accounts and saved games.",
    category: ["React", "Next.js", "Chess", "Full-Stack"],
    link: "https://chessie-five.vercel.app/",
    coverImage: "/projects/chessie.png",
    type: "image"
  },
  {
    title: "STYLE LIBRARY",
    description: "Curated reference of UI and print styles for design briefs, mood boards, and LLM prompts. Each style ships with named color schemes, hex tokens (background, surface, text, accent, muted, line), and visual element ornaments, covering Neoclassical, Baroque, Aurora, Ethereal, Pixel Art, Japandi, Memphis, Bohemian, Art Deco, Art Nouveau, Bauhaus, Brutalism, Y2K, and more. Lock the look before a single pixel gets pushed.",
    category: ["UI/UX", "Design System", "Reference", "Next.js"],
    link: "https://style-library-phi.vercel.app/",
    coverImage: "/projects/style-library.png",
    type: "image"
  },
  {
    title: "ULULATE",
    description: "Share-for-share content amplification platform. Creators post campaigns with budget and token rewards; amplifiers share via tracked links and earn payouts. Verification layer confirms legitimate shares and a transactions log records token flow. Vite + React 19 + Express + MongoDB.",
    category: ["React", "Web3", "Full-Stack", "Marketing"],
    link: "https://boomlet-git-main-wankioms-projects.vercel.app/",
    coverImage: "/projects/ululate.png",
    type: "image"
  },
  {
    title: "DOESTHISFLY",
    description: "Headline testing tool for bloggers, marketers, and content creators. Submit competing headlines, get real user votes, and surface which copy actually gets clicked. Built on Next.js 16 with Turbopack, Tailwind v4, and MongoDB Atlas.",
    category: ["Next.js", "Full-Stack", "Marketing"],
    link: "https://doesthisfly.com/",
    coverImage: "/projects/doesthisfly.png",
    type: "image"
  },
  {
    title: "BLOCKCHAIN QR PAYMENTS",
    description: "Rust and Axum API enabling walletless UX for blockchain payments. Generates QR codes that route on-chain payments without requiring the payer to manually set up a wallet, removing wallet setup as a barrier to DApp adoption.",
    category: ["Rust", "Web3", "Payments", "API"],
    github: "https://github.com/WankioM/payment-qr-api",
    coverImage: "https://storage.googleapis.com/web-vids/payment-qr.png",
    type: "image"
  },
  {
    title: "DAOBITAT",
    description: "Daobitat brings asset tokenization to real estate and SME investment in Africa. Built with Solidity smart contracts and Web3 frontend integration, it enables property ownership to be tokenized and verified on-chain, allowing co-ownership, collective decision-making, and democratized access to assets. Features security-audited smart contracts, wallet integration, and Layer 2 solutions for efficient transactions.",
    category: ["Web3", "Blockchain", "DeFi", "Smart Contracts", "Solidity", "Asset Tokenization"],
    link: "https://www.daobitat.xyz/",
    coverImage: "/projects/daobitat.png",
    type: "image"
  },
  {
    title: "VAULT89",
    description: "Landing page for an impact investment firm with consulting and real estate divisions. Built with Three.js for immersive 3D visuals, custom Blender assets, and WebGL rendering for smooth performance across devices.",
    category: ["Website", "Three.js", "3D"],
    link: "https://vault89.com/",
    coverImage: "/projects/vault89.png",
    type: "image"
  },
  {
    title: "SOBER TOKEN",
    description: "A collection of projects under DV Tech focused on mental health and addiction recovery. Powered by crypto tokens (Sober Tokens, St Newfie) to incentivize the ecosystem and enable external donor participation through smart contract-based contributions and transparent on-chain fund allocation.",
    category: ["Web3", "Blockchain", "Smart Contracts", "Tokenomics", "Social Impact"],
    link: "https://snewf.dvtechventures.com/",
    coverImage: "/projects/sobertoken.png",
    type: "image"
  },
  {
    title: "SERENITY",
    description: "Cross-platform Flutter app for sobriety and mental wellness with reward-based mechanics for addiction recovery. Shipped in-app payments, push notifications, and voice and AI mood-detection features that earned a grant from ElevenLabs. Migrated the backend from Firebase to a custom Express service. 2,000+ users in production.",
    category: ["Flutter", "Mobile", "Mental Health", "AI"],
    link: "https://play.google.com/store/apps/details?id=com.serenity.flutter_application",
    coverImage: "/projects/serenity.png",
    type: "image"
  },
 {
    title: "NATIVE CODERS",
    description: "Agency website featuring interactive 3D elements built with Three.js and custom Blender models. Combines strategic design with WebGL-powered visuals for a distinctive brand presence.",
    category: ["Website", "Three.js", "3D"],
    link: "https://www.nativecoders.se/",
    coverImage: "/projects/nativecoders.png",
    type: "image"
  },

 {
    title: "SANIDI",
    description: "A Wagmi code generator that simplifies Web3 frontend integration for developers in Swahili and English. Provides progressive guidance through chain selection, API configuration, and wallet integration setup, lowering the barrier to blockchain development.",
    category: ["Web3", "Developer Tools", "Blockchain"],
    link: "https://sanidilab.vercel.app/",
    coverImage: "/projects/sanidi.png",
    type: "image"
  },
  {
    title: "OMORFIA",
    description: "Cosmetic clinic website with appointment booking system. React frontend with scheduling integration and service catalog.",
    category: ["React", "Website"],
    link: "https://omorfia-three.vercel.app",
    coverImage: "/projects/omorfia.png",
    type: "image"
  },
  {
    title: "TOGETHER CREW DASHBOARD",
    description: "Dashboard UI design for a Web3 community management platform. Figma prototype featuring data visualization components, intuitive navigation patterns, and a design system for consistent scaling.",
    category: ["UI/UX", "Figma", "Web3"],
    link: "https://www.figma.com/proto/cRApK2lBri4QjzUROUQm9c/Together-Crew-Dashboard?node-id=0-1&t=UO6X1EzaEEljlfnb-1",
    coverImage: "/projects/togethercrew.png",
    type: "image"
  },
  {
    title: "NATIVE CODERS REVAMP",
    description: "Website redesign concept in Figma. Reworked information architecture, updated visual identity, and improved user flows for better conversion.",
    category: ["UI/UX", "Figma", "Branding"],
    link: "https://www.figma.com/proto/IAGVH2yL3B8HCTpeovqkRe/Untitled?page-id=0%3A1&node-id=41-60&starting-point-node-id=41%3A27&show-proto-sidebar=1&t=iAqeWjhWMuoBWNaK-1",
    coverImage: "/projects/ncrevamp.png",
    type: "image"
  },

{
    title: "VELOCITY BIKE RENTAL APP",
    description: "Mobile app UI for bike rental service. Figma prototype covering booking flows, rental management, and payment integration screens.",
    category: ["UI/UX", "Figma", "Mobile"],
    link: "https://www.figma.com/proto/IjZUfmHufeDXMw81My9H1F/Velocity?node-id=602-5&p=f&t=7p4ODr80LUqaPfbT-1&scaling=scale-down&content-scaling=fixed&page-id=0%3A1",
    coverImage: "/projects/velocity-bike.png",
    type: "image"
  },
  
{
    title: "KIJANI LANDING PAGE",
    description: "Landing page for a waste collection app focused on environmental sustainability. Clean layout with clear CTAs and service breakdowns.",
    category: ["UI/UX", "Figma", "Landing Page"],
    link: "https://www.figma.com/proto/DpG5b8FHYYFeIt5UuNKIeU/Kijani?page-id=0%3A1&node-id=1-2&p=f&viewport=473%2C-626%2C0.5&t=ksFd2CyTBtZsNQP3-1&scaling=scale-down-width&content-scaling=fixed",
    coverImage: "/projects/kijani.png",
    type: "image"
  },
 
{
    title: "VELOCITY EMAIL TEMPLATE",
    description: "Responsive email template for Velocity Bike Rental. Designed for cross-client compatibility with brand-consistent styling.",
    category: ["Email Design", "Figma", "Branding"],
    link: "https://www.figma.com/proto/qrYlgHmK6JDsvmCBIoYjca/Velocity-Email-Draft?node-id=145-1213&t=3glMKV6R3Z2ofwEs-1",
    coverImage: "/projects/velocity-email.png",
    type: "image"
  },
  
{
    title: "3D PORTFOLIO",
    description: "Blender work including product renders, animations, and environment scenes. Covers hard surface modeling, lighting setups, and material creation.",
    category: ["Blender", "3D", "Motion"],
    link: "https://tracywankio6.artstation.com/",
    coverImage: "https://storage.googleapis.com/web-vids/car.mp4",
    type: "video"
  },
  {
    title: "NA KENYA",
    description: "Website for Narcotics Anonymous Kenya featuring event listings, meeting schedules, and booking functionality. Built with React and Next.js.",
    category: ["React", "Website"],
    link: "https://www.nakenya.com/",
    coverImage: "/projects/nakenya.png",
    type: "image"
  },
 
 {
    title: "MANA STATS",
    description: "Built on The Graph protocol to index and surface Decentraland auction data. Provides subgraph queries for tracking land sales, bid history, and marketplace activity on-chain.",
    category: ["Web3", "Blockchain", "Data Indexing"],
    github: "https://github.com/WankioM/trib",
    coverImage: "https://storage.googleapis.com/web-vids/manastats.png",
    type: "image"
  },


], []);

// Reorder the canonical projects array per persona.featuredOrder. Featured
// titles come first in the order listed; everything else follows in source
// order. All 21 projects always render, only the arrangement changes.
const orderedProjects = useMemo(() => {
  const featured = persona?.projects?.featuredOrder || [];
  if (!featured.length) return projects;
  const byTitle = new Map(projects.map((p) => [p.title, p]));
  const seen = new Set();
  const head = [];
  for (const title of featured) {
    const p = byTitle.get(title);
    if (p) { head.push(p); seen.add(title); }
  }
  const tail = projects.filter((p) => !seen.has(p.title));
  return [...head, ...tail];
}, [persona, projects]);

const getAllCategories = () => {
  const categoriesSet = new Set();
  projects.forEach(project => {
    if (Array.isArray(project.category)) {
      project.category.forEach(cat => categoriesSet.add(cat));
    } else if (project.category) {
      categoriesSet.add(project.category);
    }
  });
  return Array.from(categoriesSet).sort();
};

// Filter projects based on selected category
const filteredProjects = selectedCategory
  ? orderedProjects.filter(project => {
      if (Array.isArray(project.category)) {
        return project.category.includes(selectedCategory);
      }
      return project.category === selectedCategory;
    })
  : orderedProjects;

// Reset to first page when filter changes
useEffect(() => {
  setCurrentPage(0);
}, [selectedCategory]);

const totalPages = Math.ceil(filteredProjects.length / projectsPerPage);
const currentProjects = filteredProjects.slice(
  currentPage * projectsPerPage,
  (currentPage + 1) * projectsPerPage
);

const nextPage = () => {
  setCurrentPage((prev) => (prev + 1) % totalPages);
};

const prevPage = () => {
  setCurrentPage((prev) => (prev - 1 + totalPages) % totalPages);
};

const handleCategoryFilter = (category) => {
  setSelectedCategory(category);
};

const clearFilter = () => {
  setSelectedCategory(null);
};
  const MediaComponent = ({ project }) => {
    const [errored, setErrored] = useState(false);

    if (errored) {
      return (
        <div className="w-full h-full flex flex-col items-center justify-center bg-matrix-bg font-mono text-[10px] text-matrix-dim uppercase tracking-[0.25em] p-4 text-center">
          <div className="text-matrix-phosphor mb-1">[ IMG.NULL ]</div>
          <div className="break-words">{project.title}</div>
          <div className="text-matrix-dim/60 mt-2 text-[9px]">awaiting upload</div>
        </div>
      );
    }

    if (project.type === "video") {
      return (
        <video
          autoPlay
          loop
          muted
          playsInline
          className="w-full h-full object-cover"
          onError={() => setErrored(true)}
        >
          <source src={project.coverImage} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      );
    }
    return (
      <img
        src={project.coverImage}
        alt={project.title}
        className="w-full h-full object-cover"
        onError={() => setErrored(true)}
      />
    );
  };

  return (
    <section className="bg-matrix-bg backdrop-blur-sm py-20 relative">
      {/* Subtle grid background */}
      <div className="absolute inset-0 opacity-[0.04] pointer-events-none"
           style={{ backgroundImage: 'linear-gradient(#00FF66 1px, transparent 1px), linear-gradient(90deg, #00FF66 1px, transparent 1px)', backgroundSize: '40px 40px' }} />

      {/* Section Header */}
      <div className="relative max-w-7xl mx-auto px-6 mb-16">
        <div className="font-mono text-xs text-matrix-dim tracking-[0.3em] mb-3">
          [ 002 · PROOF.OF.WORK ]
        </div>
        <h2 className="font-kelly text-6xl text-matrix-phosphor mb-4"
            style={{ textShadow: '0 0 14px rgba(0,255,102,0.5)' }}>
          PROOF_OF_WORK<span className="animate-pulse">_</span>
        </h2>
        <p className="font-mono text-sm text-matrix-pale max-w-2xl">
          <span className="text-matrix-dim">{'//'}</span> a collection of projects spanning web development, 3D design, and blockchain technology.
        </p>

        {/* Category Filter Tags */}
       <div className="flex flex-wrap gap-2 mt-8 mb-6">
          <div
            className={`inline-block font-mono text-xs uppercase tracking-[0.15em] px-3 py-2 cursor-pointer transition-all ${
              selectedCategory === null
                ? 'bg-matrix-phosphor text-matrix-bg shadow-phosphor-sm'
                : 'text-matrix-dim border border-matrix-dim/40 hover:border-matrix-phosphor hover:text-matrix-phosphor'
            }`}
            onClick={clearFilter}
          >
            &gt; all
          </div>

          {getAllCategories().map((category, idx) => (
            <div
              key={idx}
              className={`inline-block font-mono text-xs uppercase tracking-[0.15em] px-3 py-2 cursor-pointer transition-all ${
                selectedCategory === category
                  ? 'bg-matrix-phosphor text-matrix-bg shadow-phosphor-sm'
                  : 'text-matrix-dim border border-matrix-dim/40 hover:border-matrix-phosphor hover:text-matrix-phosphor'
              }`}
              onClick={() => handleCategoryFilter(category)}
            >
              {category}
            </div>
          ))}
        </div>
      </div>

      {/* Projects Grid */}
      <div className="relative max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {currentProjects.map((project, index) => (
            <div
              key={index}
              className="group relative bg-matrix-surface border border-matrix-dim/40 p-6 transition-all duration-300 hover:-translate-y-1 hover:border-matrix-phosphor hover:shadow-phosphor-sm"
              onMouseEnter={() => setHoveredProject(index)}
              onMouseLeave={() => setHoveredProject(null)}
            >
              {/* Card index tag */}
              <div className="absolute top-2 right-3 font-mono text-[10px] text-matrix-dim tracking-widest">
                {String(currentPage * projectsPerPage + index + 1).padStart(2, '0')}
              </div>

              {/* Project Image/Video */}
              <div className="relative h-48 mb-6 overflow-hidden border border-matrix-dim/30">
                <div className="absolute inset-0 bg-matrix-phosphor/5 z-10 pointer-events-none" />
                <MediaComponent project={project} />
              </div>

              {/* Category Tag */}
              <div className="flex flex-wrap gap-1.5 mb-4">
                  {Array.isArray(project.category) ? (
                    project.category.map((cat, catIndex) => (
                      <div
                        key={catIndex}
                        className="inline-block font-mono text-[10px] uppercase tracking-wider text-matrix-dim border border-matrix-dim/40 px-2 py-1 cursor-pointer hover:text-matrix-phosphor hover:border-matrix-phosphor transition-all"
                        onClick={() => handleCategoryFilter(cat)}
                      >
                        {cat}
                      </div>
                    ))
                  ) : (
                    <div
                      className="inline-block font-mono text-[10px] uppercase tracking-wider text-matrix-dim border border-matrix-dim/40 px-2 py-1 cursor-pointer hover:text-matrix-phosphor hover:border-matrix-phosphor transition-all"
                      onClick={() => handleCategoryFilter(project.category)}
                    >
                      {project.category}
                    </div>
                  )}
                </div>

              {/* Project Title */}
              <h3 className="font-kelly text-2xl text-matrix-phosphor mb-3 transform group-hover:translate-x-1 transition-transform"
                  style={{ textShadow: '0 0 8px rgba(0,255,102,0.35)' }}>
                &gt; {project.title}
              </h3>

              {/* Project Description */}
              <p className="font-mono text-xs text-matrix-pale/80 mb-6 line-clamp-3 leading-relaxed">
                {project.description}
              </p>

              {/* Links */}
              <div className="flex items-center space-x-4">
                {project.link && (
                  <a
                    href={project.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center space-x-2 text-matrix-pale hover:text-matrix-phosphor transition-colors"
                  >
                    <FiExternalLink />
                    <span className="font-mono text-xs uppercase tracking-[0.15em]">visit</span>
                  </a>
                )}
                {project.github && (
                  <a
                    href={project.github}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center space-x-2 text-matrix-pale hover:text-matrix-phosphor transition-colors"
                  >
                    <FiGithub />
                    <span className="font-mono text-xs uppercase tracking-[0.15em]">code</span>
                  </a>
                )}
              </div>
            </div>
          ))}
        </div>

        {/* Pagination Controls */}
        <div className="flex justify-center items-center space-x-6 mt-12 font-mono">
          <button
            onClick={prevPage}
            className="p-2 text-matrix-dim hover:text-matrix-phosphor transition-colors"
            aria-label="Previous page"
          >
            <FiChevronLeft size={20} />
          </button>
          <span className="text-matrix-phosphor text-sm tracking-[0.2em]">
            {String(currentPage + 1).padStart(2, '0')} / {String(totalPages).padStart(2, '0')}
          </span>
          <button
            onClick={nextPage}
            className="p-2 text-matrix-dim hover:text-matrix-phosphor transition-colors"
            aria-label="Next page"
          >
            <FiChevronRight size={20} />
          </button>
        </div>
      </div>
    </section>
  );
};

export default ProjectsSection;